// use case: 2 or more sponsor logos must share a line
import PTImage from '../image';
import styles from './sponsorLogoRow.module.scss';

const SponsorLogoRow = ({ value }: IProps) => {
	return (
		<div className={styles.sponsorLogoRow}>
			{value?.logos?.map((logo) => (
				<div key={logo._key} className={styles.sponsorLogo}>
					<PTImage value={logo} />
				</div>
			))}
		</div>
	);
};

interface IProps {
	value: {
		logos: any; //Clean up all this typing, this component is old and janky.
	};
}

export default SponsorLogoRow;
